module.exports = __webpack_public_path__ + "img/1536305675.4d13cb10.jpg";